var _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4161",
    "data-name": "Group 4161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    x2: 2.7,
    y2: 2.7,
    transform: "translate(12.726 0.574)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    x2: 2.7,
    y2: 2.7,
    transform: "translate(10.7 2.599)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    y1: 4.051,
    x2: 1.35,
    transform: "translate(0.574 11.376)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    x1: 4.051,
    y2: 1.35,
    transform: "translate(0.574 14.076)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    x1: 10.802,
    y2: 10.802,
    transform: "translate(1.924 0.574)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    x1: 10.802,
    y2: 10.802,
    transform: "translate(4.624 3.274)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ed0f06d1bc092e572fafa2bbba4ba82e.svg";
export { ForwardRef as ReactComponent };